"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu May 09 2019
 */

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author BPo
 * @author Tomas Leity
 */


var SimulationValue =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SimulationValue, _DomainObject_1$Domai);

  function SimulationValue(simulatedValue, originalValue, note, accepted) {
    var _this;

    _classCallCheck(this, SimulationValue);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimulationValue).call(this));
    _this.simulatedValue = simulatedValue;
    _this.originalValue = originalValue;
    _this.note = note;
    _this.accepted = accepted;
    return _this;
  }
  /**
   * Checks if the accepted or rejected button should be highlighted
   *
   * @returns {boolean}
   */


  _createClass(SimulationValue, [{
    key: "isTouched",
    value: function isTouched() {
      return this.accepted !== null;
    }
    /**
     * Checks if the value is accepted
     *
     * @returns {boolean}
     */

  }, {
    key: "isAccepted",
    value: function isAccepted() {
      return this.accepted === true;
    }
    /**
     * Checks if the value is rejected
     *
     * @returns {boolean}
     */

  }, {
    key: "isRejected",
    value: function isRejected() {
      return this.accepted === false;
    }
    /**
     * Adds the simulated value, clears previous states.
     *
     * @param value Simulated value
     * @returns {SimulationValue}
     */

  }, {
    key: "set",
    value: function set(value) {
      return this.copyMulti({
        simulatedValue: value,
        originalValue: null,
        note: null,
        accepted: null
      });
    }
    /**
     * Rejects this simulation with given note. This will set the accepted flag. rejection note and original value.
     *
     * @param originalValue The previous value
     * @param note Rejection note
     * @returns {SimulationValue}
     */

  }, {
    key: "reject",
    value: function reject(originalValue, note) {
      return this.copyMulti({
        accepted: false,
        note: note || null,
        originalValue: originalValue || null
      });
    }
    /**
     * Accept this simulation. The previous value will be retained in case of a rollback.
     *
     * @param originalValue The previous value
     * @param note Accept note
     * @returns {SimulationValue}
     */

  }, {
    key: "accept",
    value: function accept(originalValue, note) {
      return this.copyMulti({
        accepted: true,
        note: note || null,
        originalValue: originalValue
      });
    }
  }]);

  return SimulationValue;
}(DomainObject_1.DomainObject);

exports.SimulationValue = SimulationValue;